function audio_player() {
  const audioPlayerContainers = document.querySelectorAll('.cada-static-player-container');

  if (!audioPlayerContainers || audioPlayerContainers.length < 1) {
    return;
  }

  fetchiHeart();
  async function fetchiHeart() {
    loadScheduledShow();
    setInterval(async () => {
      await loadScheduledShow();
    }, 100000);
    setTimeout(async () => {
      await loadSong();
    }, 3000);
    setInterval(async () => {
      await loadSong();
    }, 60000);
  }

  function loadScheduledShow() {
    document.querySelector('#main-body-container').style.paddingTop = '0';

    let bg_ad = document.querySelector("#bg_ad");
    if(bg_ad) {
      bg_ad.style.top = '0';
    }

    let bg_ad_spacer = document.querySelector("#bg_ad_spacer");
    if(bg_ad_spacer) {
      bg_ad_spacer.style.marginTop = '70px';
    }

    // if (window.siteData.ihrStationUrl && window.siteData.identity) {
    //   const iheartElements = document.getElementsByClassName('iheart-link');
    //   console.log(iheartElements);
    //   for (let i = 0; i < iheartElements.length; i++) {
    //     iheartElements[i].setAttribute(
    //       'href',
    //       `${window.siteData.ihrStationUrl}?sc=staticRadioPlayer&pname=973FM&utm_source=arnSite&utm_medium=AudioPlayer&utm_campaign=${window.siteData.identity}`
    //     );
    //   }
    // }

    const showData = setOnAirFromSchedule();
    const activeShow = showData[0];
    const nextShow = showData[1];
    if (activeShow.start_time === undefined && activeShow.end_time === undefined){
      document.querySelector('#show-time').style.display = 'none';
      document.querySelector('#show-time-mobile').style.display = 'none';
    }
    else {
      const activeShowStartTime = tConv24(activeShow.start_time);
      const activeShowEndTime = tConv24(activeShow.end_time);
      document.querySelector('#show-time').innerHTML = `${activeShowStartTime} -  ${activeShowEndTime}`;
      document.querySelector('#show-time-mobile').innerHTML =`${activeShowStartTime} -  ${activeShowEndTime}`;

    }
    // if (nextShow.start_time === undefined && nextShow.end_time === undefined){
    //   document.querySelector('#next-show-time').style.display = 'none';
    //   document.querySelector('#next-show-time-mobile').style.display = 'none';
    // }
    // else {
    //   const nextShowStartTime = tConv24(nextShow.start_time);
    //   const nextShowEndTime = tConv24(nextShow.end_time);
    //   document.querySelector('#next-show-time').innerHTML = `${nextShowStartTime} - ${nextShowEndTime}`;
    //   document.querySelector('#next-show-time-mobile').innerHTML = `- ${nextShowStartTime} - ${nextShowEndTime}`;
    // }
    document.querySelector('#show-name').innerHTML = activeShow.show_name;
    document.querySelector('#show-name-mobile').innerHTML = activeShow.show_name;
    // document.querySelector('#next-show-name').innerHTML = nextShow.show_name;
    // document.querySelector('#next-show-name-mobile').innerHTML = nextShow.show_name;
    // document.querySelector('#next-show-info').innerHTML = nextShow.show_name;

    const outer = document.querySelector('#show-info-container').offsetWidth;
    const inner = document.querySelector('#show-name').offsetWidth;

    // const outerNext = document.querySelector('#next-show-info-container').offsetWidth;
    // const innerNext = document.querySelector('#next-show-name').offsetWidth;

    const outerMobile = document.querySelector('#show-name-container-mobile')
      .offsetWidth;
    const innerMobile = document.querySelector('#show-name-mobile').offsetWidth;

    if (inner >= outer) {
      document.querySelector('#show-name').classList.add('marquee-static-player');
      document.querySelector('#song-name').classList.add('marquee-static-player');
    }

    // if (innerNext >= outerNext) {
    //   document.querySelector('#next-show-name').classList.add('marquee-static-player');
    // }

    if (innerMobile >= outerMobile) {
      document
        .querySelector('#show-name-mobile')
        .classList.add('marquee-static-player');
      document
        .querySelector('#song-name-mobile')
        .classList.add('marquee-static-player');
    };
    if (activeShow.is_default === true) {
      document
        .querySelector('#show-image')
        .setAttribute('src', activeShow.player_image_url);
      document
        .querySelector('#show-image-mobile')
        .setAttribute('src', activeShow.player_image_url);
    } else {
      document
        .querySelector('#show-image')
        .setAttribute('src', activeShow.player_image_url);
      document
        .querySelector('#show-image-mobile')
        .setAttribute('src', activeShow.player_image_url);
    }

    // if (nextShow.is_default === true) {
    //   document
    //     .querySelector('#next-show-image')
    //     .setAttribute('src', nextShow.player_image_url);
    // } else {
    //   document
    //     .querySelector('#next-show-image')
    //     .setAttribute('src', nextShow.player_image_url);
    // }
  }

  async function loadSong() {
    const id = player_data.iHeartId;
    console.log('------------------FETCHING---------------');
    const res = await fetch(
      `https://au.api.iheart.com/api/v3/live-meta/stream/${id}/currentTrackMeta`,
      {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          'Content-Type': 'application/json',
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        // body: JSON.stringify(data), // body data type must match "Content-Type" header
      }
    );
    // console.log(res);
    if (res.status === 200) {
      const dataSong = await res.json();

      console.log(dataSong);

      if (dataSong.title && dataSong.artist) {
        const title = dataSong.title
          ? dataSong.title.replace(
            /\w\S*/g,
            txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
          )
          : '';
        const artist = dataSong.artist
          ? dataSong.artist.replace(
            /\w\S*/g,
            txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
          )
          : '';
        const titleArtist = `${title} - ${artist}`;
        let titleFinal;
        titleFinal = titleArtist;
        document.querySelector('#song-name').innerHTML = titleFinal;
        document.querySelector('#song-info').style.display = 'inline-block';
        // document.querySelector('#default-iheart').style.display = 'none';
        document.querySelector('#song-name-mobile').innerHTML = titleFinal;
        document.querySelector('#song-info-mobile').style.display = 'inline-block';
        // document.querySelector('#default-iheart-mobile').style.display = 'none';
      }

      // let link = 'https://www.iheart.com/';
      // if (
      //   dataSong &&
      //   dataSong.artistId &&
      //   dataSong.artistId !== -1 &&
      //   dataSong.artistId !== '-1'
      // )
      // if (window.siteData.ihrStationUrl && window.siteData.identity){
      //   link = `${window.siteData.ihrStationUrl}?sc=staticRadioPlayer&pname=973FM&utm_source=arnSite&utm_medium=AudioPlayer&utm_campaign=${window.siteData.identity}`;
      //
      // }
      // document.querySelector('#song-name-link').href = link;
      // document.querySelector('#song-name-link-mobile').href = link;
      // document.querySelector('#album-link').href = link;
      // document.querySelector('#album-link-mobile').href = link;

      let artwork = dataSong && dataSong.imagePath ? dataSong.imagePath : '';
      if (dataSong.imagePath) {
        const base64Url = btoa(artwork);
        artwork = `https://i.iheart.com/v3/url/${base64Url}?ops=fit(200,200)`;
        // document.querySelector('#icon-iHeart').style.display = 'none';
        // document.querySelector('#icon-iHeart-mobile').style.display = 'none';
        // document.querySelector('#album-artwork').setAttribute('src', artwork);
        // document.querySelector('#album-artwork').style.display = 'inline-block';
        // document
        //   .querySelector('#album-artwork-mobile')
        //   .setAttribute('src', artwork);
        // document.querySelector('#album-artwork-mobile').style.display =
        //   'inline-block';
      } else {
        // document.querySelector('#icon-iHeart').style.display = 'block';
        // document.querySelector('#icon-iHeart-mobile').style.display = 'block';
        // document.querySelector('#album-artwork').style.display = 'none';
        // document.querySelector('#album-artwork-mobile').style.display = 'none';
      }
    } else {
      // document.querySelector('#song-info').style.display = 'none';
      // document.querySelector('#song-info-mobile').style.display = 'none';
      document.querySelector('#default-iheart').style.display = 'block';
      // document.querySelector('#default-iheart-mobile').style.display = 'block';

      // document.querySelector('#icon-iHeart').style.display = 'block';
      // document.querySelector('#icon-iHeart-mobile').style.display = 'block';
      // document.querySelector('#album-artwork').style.display = 'none';
      // document.querySelector('#album-artwork-mobile').style.display = 'none';
    }
  }

  function setOnAirFromSchedule() {
    const scheduleJSON = player_data.schedule;
    const timeZoneOffset = player_data.timeZoneOffset;
    let dataActiveShow = false;
    let dataNextShow = false;
    const schedule = JSON.parse(scheduleJSON);
    console.log(schedule);

    const date = new Date();
    let day = date.getDay();
    if (day === 0) {
      day = 7;
    }


    // Resolving the time zone of the users.
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;


    let scheduleTime = new Date().toLocaleString('en-au', {timeZone:'Australia/Sydney'});
    let userTime = new Date().toLocaleString('en-au', {timeZone:tz})

    // function to get the timestamp
    function getTimeStamp (time) {
      let day = new Date(time).getDay();
      if (day === 0) {
        day = 7;
      }
      const timestamp_sequence =
        (day - 1) * 1440 +
        new Date(time).getHours() * 60 +
        new Date(time).getMinutes() +
        new Date(time).getTimezoneOffset();

      return timestamp_sequence;
    }

    // getting the time difference between two timezone
    let timeDifference = getTimeStamp(scheduleTime) - getTimeStamp(userTime)

    const current_timestamp_sequence =
    (day - 1) * 1440 +
    date.getHours() * 60 +
    date.getMinutes() +
    date.getTimezoneOffset() +
    timeZoneOffset * 60 + timeDifference;


    let current_show;
    let next_show;
    const default_show = schedule.default;


    if (
      typeof schedule === 'undefined' ||
      typeof schedule.shows === 'undefined'
    ) {
      console.error('no schedule available');
      return false;
    }

    for (let i = 0; schedule.shows && i < schedule.shows.length; i++) {
      if (
        current_timestamp_sequence >= schedule.shows[i].start_time_stamp &&
        current_timestamp_sequence < schedule.shows[i].end_time_stamp
      ) {
        current_show = schedule.shows[i];
        next_show = schedule.shows[i + 1];
        break;
      }
    }

    if (current_show) {
      if (current_show.alt_use_default === true) {
        current_show.alt_image = default_show.alt_image;
        current_show.alt_link = default_show.alt_link;
        current_show.alt_text = default_show.alt_text;
      }
      dataActiveShow = current_show;
    } else {
      dataActiveShow = default_show;
      dataActiveShow.is_default = true;
    }

    if (!current_show) {
      for (let i = 0;  schedule.shows && i < schedule.shows.length; i++) {
        if(current_timestamp_sequence < schedule.shows[i].start_time_stamp) {
          next_show = schedule.shows[i];
          break;
        }
      }
    }

    if (next_show) {
      if (next_show.alt_use_default === true) {
        next_show.alt_image = default_show.alt_image;
        next_show.alt_link = default_show.alt_link;
        next_show.alt_text = default_show.alt_text;
      }
      dataNextShow = next_show;
    } else {
      dataNextShow = default_show;
      dataNextShow.is_default = true;
    }

    let data = [dataActiveShow, dataNextShow];
    return data;
  }

  function tConv24(time24) {
    var ts = time24;
    var H = +ts.substr(0, 2);
    var h = (H % 12) || 12;
    h = (h < 10)?("0"+h):h;  // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? " AM" : " PM";
    ts = h + ts.substr(2, 5) + ampm;
    return ts.replace(':', '.');
  };
};

audio_player();

